import React from "react";
import SoldQuantitiesIcon from "../../../icons/SoldQuantitiesIcon";
import DetailStatisticsIcon from "../../../icons/DetailStatisticsIcon";

const ExportDecision = props => {
    const { cancel, valid } = props;

    const buildTitle = () => {
        return <p className={"title"}>Que souhaitez-vous exporter ?</p>
    }
    const buildContent = () => {
        return <div className={"nav double"}>
            <div className={"choice"} onClick={() => { valid(1) }}>
                <DetailStatisticsIcon />
                <p className={"title"}>Statistiques détaillées</p>
            </div>
            <div className={"choice"} onClick={() => { valid(2) }}>
                <SoldQuantitiesIcon />
                <p className={"title"}>Produits vendus</p>
            </div>
        </div>
    }

    return <div className={"actionDefined"}>
        <div className={"box"}>
            { buildTitle() }
            { buildContent() }
            <p className={"close"} onClick={cancel}>Annuler</p>
        </div>
    </div>
}

export default ExportDecision;
